/* prettier-ignore */
const NoFundsFoundFooter = () => {
    return (
      <footer
        id="mutual-fund-finder-footer"
        className="u-decoBackgroundWhite u-paddingHoriz3gu u-paddingVert2gu u-animFadeInUp"
      >
        Not finding what you&apos;re looking for? Try another product, share
        class, asset class or{' '}
        <a className="Link" href="/investment-products/">
          view all products
        </a>.
      </footer>
    )
  }

export default NoFundsFoundFooter
